export function getOperatingSystem() {
  const userAgent = window.navigator.userAgent;
  let os = 'Unknown OS';

  if (userAgent.indexOf('Win') !== -1) {
    os = 'Windows';
  } else if (userAgent.indexOf('Mac') !== -1) {
    os = 'macOS';
  } else if (userAgent.indexOf('Linux') !== -1) {
    os = 'Linux';
  } else if (userAgent.indexOf('Android') !== -1) {
    os = 'Android';
  } else if (userAgent.indexOf('like Mac') !== -1 && userAgent.indexOf('iPhone') !== -1) {
    os = 'iOS'; // For iOS devices
  }

  return os;
}
